import SwappableSelectController from './swappable-select.controller';
import { SwappableSelectViewProps } from './swappable-select.model';

const SwappableSelect = (props: SwappableSelectViewProps) => {
  return <SwappableSelectController {...props} />;
};

export default SwappableSelect;
